// import {Base64} from 'js-base64';
// import {getToken} from '@/util/auth'
// import website from '@/config/website';
// import download from './download.js';
// import fileDownload from 'js-file-download'
import {encrypt} from './encrypt'

export default function(url,params,fileName,fileType) {
  console.log(fileName,fileType)
  // get 打开新窗口
  let href = praseParam(url,params);
  window.open(href)
  return;

  // const x = new XMLHttpRequest()
  // if(!params) {
  //   x.open("GET",url,true)
  // }else{
  //   x.open("POST",url,true)
  //   x.setRequestHeader("Content-Type","application/json;charset=UTF-8")
  // }
  // const meta = (document.getElementsByTagName('meta') || {})
  // const isToken = meta.isToken === false;
  // x.responseType="blob";
  // x.setRequestHeader("Authorization",`Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`)
  // if(getToken() && !isToken){
  //   x.setRequestHeader("Blade-Auth", `bearer ${getToken()}`)
  // }
  // x.onload=function(){
  //   var blob=x.response;
  //   if (fileName && fileType){
  //     download(blob,fileName,fileType)
  //     // fileDownload(blob,fileName,fileType)
  //   } else if (fileName) {
  //     // fileDownload(blob,fileName)
  //     download(blob,fileName)
  //   }
  //   // window.open(x.response)
  // }
  // if(params) {
  //   return x.send(JSON.stringify(params))
  // }
  // x.send()
}

//下载文件
// function download(data, fileName, fileType) {
//   if (!data) {
//     return;
//   }
//   var blob = new Blob([data], {
//     type: fileType
//       ? fileType
//       : "application/vnd.ms-excel"
//   });
//   var url = window.URL.createObjectURL(blob);
//   var aLink = document.createElement("a");
//   aLink.style.display = "none";
//   aLink.href = url;
//   aLink.setAttribute(
//     "download",
//     fileName ? fileName : new Date().getTime()
//   );
//   document.body.appendChild(aLink);
//   aLink.click();
//   document.body.removeChild(aLink); //下载完成移除元素
//   window.URL.revokeObjectURL(url); //释放掉blob对象
// }

function praseParam(url, params){
  if(params != undefined){
    let queryStr = 'query=' + encodeURIComponent(encrypt(params))
    url += (url.indexOf('?') != -1 ? '&' : '?' ) + queryStr
  }
  // for (const key in params) {
  //   if (params.hasOwnProperty(key)) {
  //     const element = params[key];
  //     console.log(key,element)
  //     queryStr += key + '=' + element + '&'
  //   }
  // }
  // queryStr = queryStr.substring(0,queryStr.length-1);
  return url
}
